import { Component, OnInit, OnDestroy } from '@angular/core';
import { Route, ActivatedRoute, Router } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { ToasterService } from 'src/app/_services/toaster.service';
import { SuperUserService, UserService } from 'src/app/_services/generatedServices';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';
import { ISasToken } from 'src/app/_services/azureStorage';
import { BlobStorageService } from 'src/app/_services/blob-storage.service';
import { map } from 'rxjs/operators';
import { AzureBlobSASViewModel, StringViewModel } from 'src/app/_models/generatedModels';

interface IUploadProgress {
  filename: string;
  progress: number;
}

@Component({
  selector: 'bxl-upload-course-video',
  templateUrl: 'upload-course-video.component.html'
})
export class UploadCourseVideoComponent implements OnInit, OnDestroy {
  initialized = false;
  public uploadData: AzureBlobSASViewModel;
  private routeSubscription: Subscription;
  currentFile: any;
  uploading = false;
  percentComplete: number = -1;
  uploadProgress$: Observable<IUploadProgress[]>;
  courseId: number;

  constructor(private http: HttpClient, private superUserService: SuperUserService, private blobStorage: BlobStorageService, private route: ActivatedRoute, private user: UserService, private router: Router, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.paramMap.subscribe(params => {
      this.courseId = parseInt(params.get('courseId'), 10);

      // this.user.getSASForAssetContainer(this.courseId).subscribe(result => {
      //   this.uploadData = result;
      this.initialized = true;
      //   console.log(this.uploadData);
      // });
    });
  }

  onFileChange(event) {
    this.currentFile = event.target.files[0];
    this.percentComplete = 1;

    let model = new StringViewModel();
    model.value = this.currentFile.name;
    this.superUserService.getSASForVideoContainer(model).subscribe((result) => {
      this.uploadData = result;
      console.log(this.uploadData);

      this.uploadFile(this.currentFile).subscribe(
        (progress) => {
          if (progress.progress === 0) {
            this.percentComplete = 1;
          } else {
            this.percentComplete = progress.progress;
          }
        },
        (error) => {},
        () => {
          this.successEventHandler(null);
        }
      );
    });
  }

  uploadFile(file: File): Observable<IUploadProgress> {
    const accessToken: ISasToken = {
      container: this.uploadData.containerName,
      filename: file.name,
      storageAccessToken: this.uploadData.sasToken,
      storageUri: this.uploadData.storageUri
    };

    return this.blobStorage.uploadToBlobStorage(accessToken, file).pipe(map(progress => this.mapProgress(file, progress)));
  }

  private mapProgress(file: File, progress: number): IUploadProgress {
    return {
      filename: file.name,
      progress: progress
    };
  }

  // successEventHandler(e) {
  //   this.user.assetUploadComplete(this.courseId).subscribe(result => {
  //     this.toaster.messageDialog('Your course has been submitted and will be reviewed by a BCBA for CEU eligibilty.', 'Upload Complete').subscribe(result => {
  //       this.router.navigate(['listings'], { relativeTo: this.route.parent });
  //     });
  //   });
  // }

  successEventHandler(e) {
    console.log(this.uploadData);
    this.uploadData.fileName = this.currentFile.name;
    this.user.assetUploadComplete(this.courseId, this.uploadData).subscribe((result) => {
      this.toaster.messageDialog('Your course has been submitted and will be reviewed by a BCBA for CEU eligibilty.', 'Upload Complete').subscribe(result => {
        this.router.navigate(['listings'], {relativeTo: this.route.parent});
      });
    });
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }
}
